import React from 'react'
import {
	AddShoppingCartOutlined,
	RemoveShoppingCartOutlined
} from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import c from 'classnames'

import styles from './Photo.module.scss'

import {
	MediaItemInterface,
	PricelistItemInterface,
	ReducerStoreInterface
} from '../../utils/interfaces'
import { STORAGE } from '../../utils/consts'
import {
	setCart,
	setCartAdditional,
	setPhotoModal
} from '../../store/reducers/data'

interface PhotoInterface {
	photo: MediaItemInterface
	step: number
}

const Photo = ({ photo, step }: PhotoInterface) => {
	const dispatch = useDispatch()
	const { pricelist, cart, cartAdditional } = useSelector(
		(reduxStore: ReducerStoreInterface) => reduxStore.data
	)

	const [qty, setQty] = React.useState(0)
	const [attributes, setAttributes] = React.useState<PricelistItemInterface>()
	const [optionsStep, setOptionsStep] = React.useState([0])

	React.useEffect(() => {
		console.log('attributes', attributes)
	}, [attributes])

	const addToCartHandler = (key?: number) => {
		if (photo.collection_name === 'dodatne') {
			const updatedCart = [
				...cartAdditional,
				{
					key: key,
					id: photo.id,
					file_name: photo.file_name,
					quantity: qty,
					collection_name: photo.collection_name,
					attributes: attributes,
					price: attributes?.price
				}
			]
			dispatch(setCartAdditional(updatedCart))
			setOptionsStep([...optionsStep, optionsStep.length])
			setQty(0)
			setAttributes(undefined)
		} else {
			const updatedCart = [
				...cart.filter((c: MediaItemInterface) => c.id !== photo.id),
				{
					id: photo.id,
					file_name: photo.file_name,
					quantity: 1,
					collection_name: photo.collection_name,
					attributes: attributes,
					price: attributes?.price
				}
			]
			dispatch(setCart(updatedCart))
		}
	}

	const removeFromCartHandler = (key: number) => {
		if (photo.collection_name === 'dodatne') {
			const others = []
			const same = []
			for (const cartItem of cartAdditional) {
				if (cartItem.id !== photo.id) {
					others.push(cartItem)
				} else {
					same.push(cartItem)
				}
			}
			const updatedSame = same.filter((s) => s.key !== key)
			const updatedCart = [...others, ...updatedSame]
			dispatch(setCartAdditional(updatedCart))
			const optionStepUpdated = optionsStep.filter((opt) => opt !== key)
			setOptionsStep(optionStepUpdated.length === 1 ? [0] : optionStepUpdated)
		} else {
			const updatedCart = [
				...cart.filter((c: MediaItemInterface) => c.id !== photo.id)
			]
			dispatch(setCart(updatedCart))
		}
	}

	const isAddedToCard = (key: number) => {
		if (step === 4) {
			return !!cartAdditional.find(
				(c) =>
					c.id === photo.id && c.key === key && c.collection_name === 'dodatne'
			)
		} else {
			return !!cart.find((c) => c.id === photo.id)
		}
	}

	const isAddable = (key: number) => {
		if (step === 4) {
			return !cartAdditional.find(
				(c) =>
					c.id === photo.id && c.key === key && c.collection_name === 'dodatne'
			)
		} else {
			return !cart.find((c) => c.collection_name === photo.collection_name)
		}
	}

	const getOptions = () => {
		const options: any[] = []
		optionsStep.map((i) => {
			options.push(
				<div className={styles.options} key={i}>
					{step === 4 && (
						<React.Fragment>
							{pricelist.items.length > 0 && (
								<label>
									Opcije
									<select
										name="format"
										id="format"
										onChange={(event) => {
											const pricelistItem = pricelist.items.find(
												(item) => item.id.toString() === event.target.value
											)
											setAttributes(pricelistItem)
										}}
									>
										<option value="" hidden selected>
											Odaberite opciju...
										</option>
										{pricelist.items.map((item, index) => (
											<option value={item.id} key={index}>
												{item.name} ({item.price} din.)
											</option>
										))}
									</select>
								</label>
							)}
							<label>
								Količina
								<input
									type="number"
									defaultValue={0}
									min={0}
									onChange={(event) =>
										Number(event.target.value) > 0 &&
										setQty(Number(event.target.value))
									}
								/>
							</label>
						</React.Fragment>
					)}
					<div className={styles.buttonWrapper}>
						{isAddedToCard(i) && (
							<button
								className={styles.remove}
								onClick={() => removeFromCartHandler(i)}
							>
								UKLONI <RemoveShoppingCartOutlined />
							</button>
						)}
						{isAddable(i) && (
							<button
								className={c(
									styles.add,
									step === 4 && qty === 0 && styles.disabled
								)}
								onClick={() => addToCartHandler(i)}
								disabled={step === 4 && qty === 0}
								title={
									step === 4 && qty === 0 ? 'Odaberite opciju i količinu' : ''
								}
							>
								DODAJ <AddShoppingCartOutlined />
							</button>
						)}
					</div>
				</div>
			)
		})
		return options
	}

	return (
		<div className={styles.photo}>
			<img
				src={`${STORAGE}/${photo.id}/${photo.file_name}`}
				alt={photo.file_name}
				onClick={() => dispatch(setPhotoModal(photo))}
				title="Klikni za uvećanje"
			/>
			<div className={styles.optionsWrapper}>{getOptions()}</div>
		</div>
	)
}

export default Photo
